import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';

import CheckIcon from '@material-ui/icons/Done';
import Typography from '@material-ui/core/Typography';
import { makeStyles, useTheme } from '@material-ui/core/styles';

import bankIcon from 'assets/nav-menu/accounts.svg';

const useStyles = makeStyles((theme) => ({
  chipRoot: {
    height: 80,
    borderRadius: 8,
    margin: 8,
    width: 'calc(50% - 16px)',
    overflow: 'hidden',
    border: `2px solid ${theme.palette.greyScale[5]}`,
    padding: '14px 16px',
    position: 'relative',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    backgroundColor: theme.palette.greyScale[7],
    '&:hover': {
      border: `2px solid ${theme.palette.greyScale[4]}`,
      boxShadow: `0 1px 4px 0 ${theme.applyOpacityToHex(theme.palette.greyScale[0], 0.12)}`,
    },
  },
  smallSlash: {
    position: 'absolute',
    left: -8,
    height: 92,
    width: 44,
    backgroundColor: theme.applyOpacityToHex(theme.palette.secondary.dark, 0.2),
    transform: 'rotate(-12deg)',
  },
  icon: {
    zIndex: 0,
  },
  iconBank: {
    extend: 'icon',
    backgroundColor: theme.palette.greyScale[6],
    border: `1px solid ${theme.palette.greyScale[4]}`,
    borderRadius: 4,
    height: 36,
    width: 56,
  },
  iconFds: {
    extend: 'icon',
    borderRadius: 4,
    height: 36,
  },
  iconPlaid: {
    extend: 'icon',
    height: 48,
    width: 48,
  },
  stacked: {
    width: 228,
    padding: '0 16px',
  },
  greenCheck: {
    color: theme.palette.greyScale[7],
    backgroundColor: theme.palette.secondary.main,
    borderRadius: '50%',
    padding: 2,
  },
}));

export default function AccountChip(props) {
  const { data } = props;
  const theme = useTheme();
  const classes = useStyles();

  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setTimeout(() => setMounted(true), 0);
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  let logoClasses = null;
  let logoSrc = null;
  switch (data.aggregator) {
    case 'FDS':
      if (data.logoUrl) {
        logoSrc = data.logoUrl;
        logoClasses = classes.iconFds;
      }
      break;
    case 'PLAID':
      if (data.logo) {
        logoSrc = `data:image/svg;base64, ${data.logo}`;
        logoClasses = classes.iconPlaid;
      }
      break;
    default:
      break;
  }
  if (!logoSrc) {
    logoSrc = bankIcon;
    logoClasses = classes.iconBank;
  }

  return (
    <div
      className={classes.chipRoot}
      id={data.name}
      style={{
        transform: mounted ? 'rotate3d(1, 0, 0, 0)' : 'rotate3d(1, 0, 0, -90deg)',
        transition: `transform 0.5s ease`,
        transformOrigin: '0 0 5px',
      }}
    >
      <div className={classes.smallSlash} style={{ backgroundColor: data.primaryColor && theme.applyOpacityToHex(data.primaryColor, 0.2)}}/>
      <img alt={data.name} src={logoSrc} className={logoClasses}/>
      <div className={classes.stacked}>
        <Typography variant="body1" className={classes.bolder} noWrap>
          {data.name}
        </Typography>
        <Typography variant="caption">
          {data.isManual ? 'Manual' : 'Connected'}
        </Typography>
      </div>
      <CheckIcon className={classes.greenCheck}/>
    </div>
  );
}

AccountChip.propTypes = {
  data: PropTypes.object,
};
